import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
export default class LayerAnimateStylePlugin {
  apply(layer) {
    layer.hooks.beforeRender.tap('LayerAnimateStylePlugin', () => {
      // @ts-ignore
      const animateStatus = layer.animateStatus;
      if (animateStatus) {
        layer.models.forEach(model => {
          model.addUniforms(_objectSpread({}, layer.layerModel.getAnimateUniforms()));
        });
      }
    });
  }
}